import React, { useState } from 'react';
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import DialogView from './DialogView';
import { useTranslation } from './LocalizationProvider';
import { useGlobalStyles } from '../util/classes';

const TransferDialog = ({ open, handleClose }) => {
  const t = useTranslation();
  const classes = useGlobalStyles();
  const [item, setItem] = useState();

  const validate = () => item && item.email;

  if (!item) {
    setItem({ email: '', notify: false });
  }

  return (
    <DialogView
      item={item}
      open={open}
      handleClose={handleClose}
      dialogTitle={t('sharedTransferTo')}
      acceptTitle={t('sharedTransfer')}
      validate={validate}
      content={item && (
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell className={classes.cell}>
                <TextField
                  value={item.email || ''}
                  label={t('userEmail')}
                  onChange={(event) => setItem({ ...item, email: event.target.value })}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={item.notify} onChange={(event) => setItem({ ...item, notify: event.target.checked })} />}
                    label={t('sharedNotify')}
                  />
                </FormGroup>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    />
  );
};

export default TransferDialog;
